import { useMemo } from "react";
import { keepPreviousData, InfiniteData } from "@tanstack/react-query";
import { useCachedInfiniteQuery } from "@/hooks/useCachedQuery";
import useAccount from "@/modules/account/hooks/useAccount";
import { ContractorPanelCardService } from "../services/contractorPanelCardService";
import { ReadContractorCard } from "@/types/contractorCard";
import { SuccessFetchListResponse } from "@/services/api";
import { Module } from "@/constants";

export const useContractorPanelCardsList = () => {
  const { account } = useAccount();

  const queryKey = useMemo(
    () => [Module.ContractorPanelCards, account?.contractor_id],
    [account?.contractor_id],
  );

  return useCachedInfiniteQuery<
    SuccessFetchListResponse<ReadContractorCard>,
    Error,
    InfiniteData<SuccessFetchListResponse<ReadContractorCard>>,
    typeof queryKey,
    string | undefined
  >({
    queryKey,
    queryFn: async ({ pageParam }) =>
      ContractorPanelCardService.getList({
        lastItem: pageParam,
        sorting: { id: "period", desc: true },
      }),
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => lastPage.last_item,
    placeholderData: keepPreviousData,
    refetchOnReconnect: true,
    enabled: !!account?.contractor_id,
  });
};
